import React from "react";
import styles from "../../assets/styles/Support/Support.module.scss";
import {
  MimaButton,
  MimaDropdown,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../components";
import moment from "moment";
import { Formik } from "formik";

const ViewMoreSupport = ({
  closeModal,
  data,
  loading,
  onSubmit,
  stage,
  setStage,
  validationSchema,
}) => {
  return (
    <Modal closeModal={closeModal}>
      {stage !== "STAGE2" ? (
        <>
          <div className={styles.btnContainer}>
            <MimaButton
              title="Update status"
              onClick={() => {
                setStage("STAGE2");
              }}
            />
          </div>
        </>
      ) : null}

      <MimaText variant="subtitleBold" mb={2}>
        Support
      </MimaText>

      <div className={styles.modalContent}>
        <MimaText labelTitle="Business" align="left" mb={2}>
          {data?.business?.tradingName}
        </MimaText>
        <MimaText labelTitle="Date Raised" align="left" mb={2}>
          {moment(data.createdAt).format("DD/MM/YYYY HH:mm a")}
        </MimaText>

        <MimaText labelTitle="Title" align="left" mb={2}>
          {data.title}
        </MimaText>

        <MimaText labelTitle="Description" align="left" mb={2}>
          {data.message}
        </MimaText>
        {data.imageUrls.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              marginTop: "2rem",
              gap: "2rem",
              margin: "2rem 0",
            }}
          >
            <MimaText variant="small" color="var(--color-primary)">
              Support Image/File
            </MimaText>
            {/* <img src={data.imageUrls[0] || ""} alt="preview" width="380rem" /> */}
            <div style={{ textAlign: "center" }}>
              <div style={{ display: "inline-block" }}>
                {data.imageUrls[0].endsWith(".pdf") ? (
                  <>
                    <iframe
                      src={data.imageUrls[0] || ""}
                      title="PDF Viewer"
                      width="100%"
                      height="500rem"
                    />
                    <div>
                      <a href={data.imageUrls[0] || ""} download="file.pdf">
                        Download PDF
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={data.imageUrls[0] || ""}
                      alt="Preview"
                      style={{ maxWidth: "100%", maxHeight: "500rem" }}
                    />
                    <div>
                      <a href={data.imageUrls[0] || ""} download="file.jpg">
                        Download Image
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {data?.url && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              marginTop: "2rem",
              gap: "2rem",
              margin: "2rem 0",
            }}
          >
            <MimaText variant="small" color="var(--color-primary)">
              Support Image/File
            </MimaText>
            {/* <img src={data.imageUrls[0] || ""} alt="preview" width="380rem" /> */}
            <div style={{ textAlign: "center" }}>
              <div style={{ display: "inline-block" }}>
                {data.url.endsWith(".pdf") ? (
                  <>
                    <iframe
                      src={data.imageUrls[0] || ""}
                      title="PDF Viewer"
                      width="100%"
                      height="500rem"
                    />
                    <div>
                      <a href={data.imageUrls[0] || ""} download="file.pdf">
                        Download PDF
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={data.url || ""}
                      alt="Preview"
                      style={{ maxWidth: "100%", maxHeight: "500rem" }}
                    />
                    <div>
                      <a href={data.url || ""} download="file.jpg">
                        Download Image
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        <MimaText labelTitle="Status" align="left" mb={2}>
          <div
            className={`status ${data.status === "CLOSED" ? "status__green" : data.status === "PROCESSING" ? "status__dark__yellow" : "status__red"}`}
          >
            {data.status}
          </div>
        </MimaText>

        {data.audits.length > 0 && (
          <>
            <MimaText
              variant="small"
              color="var(--color-primary)"
              mb={1}
              mt={1}
            >
              Status updates
            </MimaText>
            {data?.audits?.map((x) => (
              <div key={x._id}>
                <MimaText mb={2}>
                  {`${x?.activity}: ${x.admin.firstname} ${x.admin.lastname} ${moment(x.createdAt).format("DD/MM/YYYY HH:mm a")}`}
                </MimaText>
              </div>
            ))}
          </>
        )}

        {stage === "STAGE2" ? (
          <>
            <Formik
              initialValues={{
                status: data?.status || "",
                activity: "",
              }}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {({
                handleBlur,
                handleChange,
                setFieldValue,
                values,
                errors,
                touched,
                handleSubmit,
              }) => (
                <>
                  <MimaDropdown
                    labelTitle="Status"
                    placeholder="Select Status"
                    name="status"
                    value={values.status}
                    id="status"
                    data={[
                      { value: "OPEN", key: "OPEN" },
                      { value: "CLOSED", key: "CLOSED" },
                      { value: "PROCESSING", key: "PROCESSING" },
                    ]}
                    onChange={(data) => {
                      setFieldValue("status", data.key);
                    }}
                    error={errors.status}
                    touched={touched.status}
                    onBlur={handleBlur}
                  />
                  <MimaTextArea
                    variant="Comment"
                    placeholder="Make a comment"
                    name="activity"
                    value={values.activity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.activity}
                    touched={touched.activity}
                  />
                  <MimaButton
                    title="Save"
                    type="submit"
                    onClick={handleSubmit}
                    mt={2}
                    width="38"
                    buttonColor="#60607A"
                    loading={loading}
                  />
                </>
              )}
            </Formik>
          </>
        ) : null}
      </div>
    </Modal>
  );
};
export default ViewMoreSupport;
